<template>
  <div class="timer">
    <slot />
  </div>
</template>

<script>
export default {
  name: "Timer",
};
</script>

<style lang="scss" scoped>
.timer {
  @include red-shadow;
  @include circle(48px);
  display: inline-flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: $size-font-1;
  color: $color-text-inverted;
  background-color: $color-primary;
  overflow: hidden;
  border: none;
}
</style>
